import { useMarketHomeGoodsQuery } from '../queries/useMarketHomeGoodsQuery';
import { useParentMarketHomeGoodsQuery } from '../queries/useParentMarketHomeGoodsQuery';
import { useHasParentMarket } from './useHasParentMarket';
import type { MarketGoodsListFilter } from '../states/GoodsListFilter.atom';

export const useMarketHomeGoods = (
  marketId: number,
  filters: MarketGoodsListFilter,
) => {
  const { hasParentMarket } = useHasParentMarket(marketId);

  const marketGoodsQuery = useMarketHomeGoodsQuery(
    {
      marketId,
      filters,
    },
    {
      enabled: hasParentMarket === false,
    },
  );

  const parentMarketGoodsQuery = useParentMarketHomeGoodsQuery(
    {
      marketId,
      filters,
    },
    {
      enabled: hasParentMarket,
    },
  );

  if (hasParentMarket === true) {
    return parentMarketGoodsQuery;
  }

  return marketGoodsQuery;
};
